/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { AiFillMessage } from "react-icons/ai";
import { FaChevronRight } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import ChatMessageViewModal from "../../components/modal/ChatMessageViewModal";
import EditMessage from "../../components/modal/EditMessage";
import lags from "../../images/lags.png";
import { getApiCaller } from "../../libs/apiCaller";
import CostModal from "../../components/modal/CostModal";

const ScheduledAppointmentDetail = () => {
  const [editMessageModal, setEditMessageModal] = useState(false);
  const [chatViewModal, setChatViewModal] = useState(false);
  const [remainingTime, setRemainingTime] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const consumerId = location.state?.consumerId;
  const bookingId = location.state?.bookingId;
  const consumerName = location.state?.consumerName;
  // const type = location.state?.type;
  const [detailsInfo, setDetailsInfo] = useState(null);
  const [costPriceModal, setCostPriceModal] = useState(false);

  const fetchCompleteAppoinmentsDetails = async () => {
    try {
      const response = await getApiCaller(
        `appointment_details?booking_id=${bookingId}`
      );
      setDetailsInfo(response.data.response_data);
    } catch (error) {
      toast.error("Failed to fetch pending providers. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    bookingId && fetchCompleteAppoinmentsDetails();
  }, [bookingId]);

  useEffect(() => {
    const created_at = parseDate("17-02-2025 23:30:21");
    startCountdown(created_at);
  }, []);

  const parseDate = (dateString) => {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("-");
    const [hours, minutes, seconds] = timePart.split(":");
    return new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
  };

  // Function to start the countdown
  const startCountdown = (appointmentDate) => {
    const interval = setInterval(() => {
      const now = new Date();
      const endTime = new Date(appointmentDate.getTime() + 24 * 60 * 60 * 1000); // 24 hours later
      const timeLeft = endTime - now;

      if (timeLeft <= 0) {
        clearInterval(interval);
        setRemainingTime("00:00:00");
      } else {
        const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        const seconds = Math.floor((timeLeft / 1000) % 60);
        setRemainingTime(`${hours}h ${minutes}m ${seconds}s`);
      }
    }, 1000); // Update every second
  };

  return (
    <>
      <div className="px-4 md:px-10 mt-4">
        {/* Main container with flex column on mobile, row on desktop */}
        <div className="flex flex-col lg:flex-row justify-between gap-4 lg:gap-0">
          {/* Breadcrumb navigation */}
          <nav className="flex flex-wrap items-center gap-2 text-[13px] sm:text-base lg:text-xl">
            <a href="/consumer" className="text-[#284184] hover:underline">
              All Consumers
            </a>
            <FaChevronRight className="text-[#284184] w-3 h-3 md:w-4 md:h-4" />

            <a
              href={`/consumerProfile/${consumerId}`}
              className="text-[#284184] hover:underline"
            >
              {consumerName}
            </a>
            <FaChevronRight className="text-[#284184] w-3 h-3 md:w-4 md:h-4" />

            <span className="text-[#284184] font-bold">Scheduled</span>
          </nav>

          {/* Button group */}
          <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
            <button className="bg-[#FFEED0] text-[#F04438] px-3 py-2 md:px-4 rounded-xl text-sm sm:text-xl font-semibold whitespace-nowrap">
              Cancel
            </button>
            <button className="bg-[#284184] text-white px-3 py-2 md:px-4 rounded-xl text-sm sm:text-xl font-semibold whitespace-nowrap">
              Reschedule
            </button>
            <button className="bg-[#284184] text-white px-3 py-2 md:px-4 rounded-xl text-sm sm:text-xl font-semibold whitespace-nowrap">
              Change Provider
            </button>
          </div>
        </div>
        {loading ? (
          <div className="flex justify-center items-center h-[70vh]">
            <PropagateLoader color="#284184" loading={true} size={10} />
          </div>
        ) : (
          <>
            <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
              <div className="flex justify-between items-center">
                <p className="text-[#284184] font-bold">Appointments Detail</p>
                <div
                  className="rounded-lg bg-[#E9F2FF] p-3 cursor-pointer"
                  onClick={() => setChatViewModal(true)}
                >
                  <AiFillMessage
                    color="#284184"
                    size={25}
                    className="cursor-pointer"
                  />
                </div>
              </div>
            </div>
            <div className="border border-1 border-t-0 px-4 py-3 rounded-b-2xl bg-white">
              <div>
                {/* Top Image */}
                <div className="mb-4 w-[100px]">
                  <img
                    src={
                      detailsInfo?.feet_media?.doc_close_up_finger_both_feet ||
                      lags
                    }
                    alt="Foot"
                    className="rounded-lg "
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {/* Provider Section */}
                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Provider Name
                    </label>
                    <p className="text-base">
                      {detailsInfo?.provider_details?.provider_name || "N/A"}
                    </p>
                  </div>

                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Email Address
                    </label>
                    <p className="text-base">
                      {detailsInfo?.provider_details?.provider_email || "N/A"}
                    </p>
                  </div>

                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Mobile Number
                    </label>
                    <p className="text-base">
                      {detailsInfo?.provider_details?.provider_country_code +
                        " " +
                        detailsInfo?.provider_details?.provider_number || "N/A"}
                    </p>
                  </div>

                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Appointment Status
                    </label>
                    <div className="flex items-center">
                      <span
                        className={`px-2 py-1 bg-[#E6F8E9] ${
                          detailsInfo?.booking_status === "Confirmed"
                            ? "text-[#00A651]"
                            : "text-[#E0A256]"
                        } rounded-md text-sm`}
                      >
                        {detailsInfo?.booking_status}
                      </span>
                    </div>
                  </div>

                  {/* Patient Section */}
                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Patient Name
                    </label>
                    <p className="text-base">
                      {detailsInfo?.patient_details?.full_name || "N/A"}
                    </p>
                  </div>

                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Patient Gender
                    </label>
                    <p className="text-base">
                      {detailsInfo?.patient_details?.gender || "N/A"}
                    </p>
                  </div>

                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">Age</label>
                    <p className="text-base">
                      {detailsInfo?.patient_details?.age || "N/A"}
                    </p>
                  </div>

                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Consumer Pay
                    </label>
                    <div className="flex items-center justify-between">
                      <p className="text-base">${detailsInfo?.final_cost}</p>
                      {detailsInfo?.coasting_details &&
                        detailsInfo?.coasting_details?.length > 0 && (
                          <button
                            className="text-[#284184] underline text-sm"
                            onClick={() => setCostPriceModal(true)}
                          >
                            View Breakup
                          </button>
                        )}
                    </div>
                  </div>

                  {/* Appointment Details */}
                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Appointment Date
                    </label>
                    <p className="text-base">{detailsInfo?.date}</p>
                  </div>

                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">Time Slot</label>
                    <p className="text-base">{detailsInfo?.time}</p>
                  </div>

                  {/* <div className="space-y-2 lg:col-span-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Remaining Time
                    </label>
                    <p className="text-base">{remainingTime}</p>
                  </div> */}

                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Is This Appointment At Hospital, RCC, Long Term Care Or
                      Retirement Home?
                    </label>
                    <p className="text-base">
                      {detailsInfo?.appointment_at_hospital}
                    </p>
                  </div>

                  {/* Medical Information */}
                  <div className="space-y-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">Room No</label>
                    <p className="text-base">{detailsInfo?.room_no || "N/A"}</p>
                  </div>

                  {/* Location Section */}
                  <div className="space-y-2 lg:col-span-2 border-b pb-2">
                    <label className="text-[#8B8D98] text-sm">
                      Service Address
                    </label>
                    <p className="text-base">
                      {detailsInfo?.service_address || "N/A"}
                    </p>
                  </div>

                  {detailsInfo?.consumer_question_ans &&
                    detailsInfo?.consumer_question_ans?.length !== 0 &&
                    detailsInfo?.consumer_question_ans?.map((queRes) => {
                      return (
                        <>
                          <div className="space-y-2 border-b pb-2">
                            <label className="text-[#8B8D98] text-sm">
                              {queRes?.question}
                            </label>
                            {!queRes?.is_multiple_ans &&
                              !queRes.is_media &&
                              queRes?.options?.map((res) => (
                                <p className="text-base">{res.options}</p>
                              ))}
                            {queRes?.is_multiple_ans &&
                              queRes?.options?.map((res) => (
                                <p className="text-base">• {res.options}</p>
                              ))}
                            {queRes.is_media &&
                              queRes?.options?.map((res) => (
                                <div className="lg:col-span-4 flex items-center space-x-4">
                                  <img
                                    src={res?.path || lags}
                                    alt="Foot"
                                    className="rounded-lg w-[100px]"
                                  />
                                  <p className="text-base">{res.options}</p>
                                </div>
                              ))}
                          </div>
                        </>
                      );
                    })}

                  {/* Custom Message */}
                  <div className="space-y-2 border-b pb-2">
                    <div className="flex items-center justify-between">
                      <label className="text-[#8B8D98] text-sm">
                        Custom Message
                      </label>
                    </div>
                    <p className="text-base">
                      {detailsInfo?.custom_message || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Artificial Intelligence Result */}
            <div className="border border-1 px-4 py-3 rounded-t-2xl mt-4 bg-white">
              <p className="text-[#284184] text-md sm:text-xl font-bold">
                Artificial Intelligence Result
              </p>
            </div>
            <div className="border border-t-0 px-4 py-3 rounded-b-2xl bg-white">
              <p className="sm:text-lg text-[#E0A256] mb-3">
                Fungus, Corn and Callus condition not detected. Nails seems to
                be too long
              </p>
              <div className="flex flex-wrap gap-3">
                <div className="p-1 w-28 md:w-48 text-center rounded-xl bg-[#DBEBFF]">
                  {/* Top Image */}
                  <div className="flex gap-3 mb-4">
                    <img
                      src={
                        detailsInfo?.feet_media?.doc_sole_area_both_feet || lags
                      }
                      alt="Foot"
                      className="rounded-t-xl w-full object-contain"
                      style={{ width: "184px", height: "245px" }}
                    />
                  </div>
                  <div className="text-wrap">
                    <p className="font-semibold text-lg">
                      Sole Area of Both Feet
                    </p>
                  </div>
                </div>
                <div className="p-1 w-28 md:w-48 text-center rounded-xl bg-[#DBEBFF]">
                  {/* Top Image */}
                  <div className="flex gap-3 mb-4">
                    <img
                      src={
                        detailsInfo?.feet_media
                          ?.doc_close_up_finger_both_feet || lags
                      }
                      alt="Foot"
                      className="rounded-t-xl w-full object-contain"
                      style={{ width: "184px", height: "245px" }}
                    />
                  </div>
                  <div className="text-wrap">
                    <p className="font-semibold text-lg">
                      Close-up of fingers of both feet
                    </p>
                  </div>
                </div>
                <div className="p-1 w-28 md:w-48 text-center rounded-xl bg-[#DBEBFF]">
                  {/* Top Image */}
                  <div className="flex gap-3 mb-4">
                    <img
                      src={
                        detailsInfo?.detailsInfo?.feet_media?.doc_toes_raised ||
                        lags
                      }
                      alt="Foot"
                      className="rounded-t-xl w-full object-contain"
                      style={{ width: "184px", height: "245px" }}
                    />
                  </div>
                  <div className="text-wrap">
                    <p className="font-semibold text-lg">
                      Toes raised above ground on the heel
                    </p>
                  </div>
                </div>
                <div className="p-1 w-28 md:w-48 text-center rounded-xl bg-[#DBEBFF]">
                  {/* Top Image */}
                  <div className="flex gap-3 mb-4">
                    <img
                      src={
                        detailsInfo?.detailsInfo?.doc_sides_of_both_feetlags ||
                        lags
                      }
                      alt="Foot"
                      className="rounded-t-xl w-full object-contain"
                      style={{ width: "184px", height: "245px" }}
                    />
                  </div>
                  <div className="text-wrap">
                    <p className="font-semibold text-lg">Sides of both feet</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <EditMessage
        isOpen={editMessageModal}
        onClose={() => setEditMessageModal(false)}
      />
      <ChatMessageViewModal
        isOpen={chatViewModal}
        onClose={() => setChatViewModal(false)}
        bookingId={String(bookingId)}
        consumerId={Number(consumerId)}
        provider={detailsInfo?.provider_details}
      />
      <CostModal
        isOpen={costPriceModal}
        onClose={() => setCostPriceModal(false)}
        detailsInfo={detailsInfo}
      />
    </>
  );
};

export default ScheduledAppointmentDetail;
